"use client";

import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { APP_NS } from "i18n";
import type { CreativeFamily } from "@features/upsell/creative";
import { CreativeCopy, getCreativeCopy } from "@data/upsells/creative";

export const useCreativeCopy = (family: CreativeFamily): CreativeCopy => {
    const { i18n } = useTranslation(APP_NS);
    return useMemo(() => getCreativeCopy(family, i18n.language), [family, i18n.language]);
};
